<template>
  <div class="usersgroup">
    <NavBar />
    <AuthBySessionExpired />
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <b-modal no-close-on-backdrop id="create" hide-footer>
          <template v-slot:modal-title>
            <h2 class="title-modal">ADICIONAR GRUPO DE USUÁRIOS</h2>
          </template>
          <Create @success="paginate" />
        </b-modal>
        <div class="row">
          <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
            <v-btn class="btn-return" @click="handleToBack">
              <i class="fas fa-arrow-left mr-2 text-twenty"> </i> Voltar
            </v-btn>
          </div>
          <div class="col-xl-5 col-lg-5 col-md-6 col-sm-9 col-12 pt-0">
            <h1 class="title-pages pt-1 check-text-center">
              GRUPO DE USUÁRIOS
            </h1>
          </div>
          <div
            class="col-xl-6 col-lg-5 col-md-4 col-sm-12 col-12 pt-0 text-right"
          >
            <v-btn
              v-if="permission('write', 'user_group')"
              class="btn-add"
              v-on:click="handleModalCreate"
            >
              <i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR
            </v-btn>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-1">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              label="Pesquisar grupo de usuários"
              outlined
              dense
            />
          </div>
        </div>
        <div class="v-clean p-5 text-center" v-show="data.length == 0">
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>
        <v-data-table
          v-show="data.length > 0"
          v-if="permission('read', 'user_group')"
          dense
          :headers="headers"
          :items="data"
          :search="search"
          :footer-props="{
            'items-per-page-options': [50, 75, 100],
            'items-per-page-text': 'Mostrar',
          }"
          @click:row="handleClickRowTable"
        >
          <template v-slot:[`item.description`]="{ item }">
            <b-modal
              no-close-on-backdrop
              :id="`edit_${String(item.id)}`"
              hide-footer
            >
              <template v-slot:modal-title>
                <h2 class="title-modal-edit">
                  EDITAR GRUPO DE USUÁRIOS
                </h2></template
              >
              <Edit @success="paginate" :item="item" />
            </b-modal>
            {{ item.description }}
          </template>
        </v-data-table>
        <ErrorsMessages :errors="errors" />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import Create from "../templates/UsersGroup/create";
import Edit from "../templates/UsersGroup/edit";

import routes from "../routes";

import api from "../services/api";

import permission from "../lib/permission";

export default {
  name: "UsersGroup",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    Create,
    Edit,
  },

  data() {
    return {
      search: "",
      headers: [
        { text: "NOME", value: "name" },
        { text: "DESCRIÇÃO", value: "description" },
      ],
      data: [],
      id: "",
      loading: false,
      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,

    handleToBack: () => routes.go(-1),

    handleModalCreate() {
      this.errors = [];
      this.$bvModal.show("create");
    },

    handleClickRowTable(item) {
      this.id = item.id;
      this.$bvModal.show(`edit_${String(item.id)}`);
    },

    async retrieve() {
      await this.paginate();
    },

    async paginate(page = 1) {
      try {
        this.loading = true;

        let params = { page };
        const response = await api.get("/rest-home/groups/paginate", {
          params,
        });

        const { error, errors, groups } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.data = groups;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
